module.exports = __webpack_public_path__ + "static/media/Screenshot4.72dddf35.png";